<rt-dialog-header>
  <rt-heading variant="heading large-x-dialog-header">
    {{ 'tlc.org.add_dialog.heading' | translate }}
  </rt-heading>
</rt-dialog-header>
<rt-dialog-body variant="white">
  <form [formGroup]="form">
    <section>
      <rt-form-field>
        <rt-label>{{ 'tlc.org.add_dialog.name.label' | translate }}</rt-label>
        <rt-input
          formControlName="name"
          [placeholder]="'tlc.org.add_dialog.name.placeholder' | translate"
        />
        <span>{{ checkNameControlValidity }}</span>
      </rt-form-field>
    </section>
    <section class="app-select">
      <div margin-bottom-small-x>
        <rt-label>{{ 'tlc.org.add_dialog.apps.heading' | translate }}</rt-label>
        <span>{{ 'tlc.org.add_dialog.apps.description' | translate }}</span>
      </div>

      <div class="card-container" margin-bottom-small>
        <rt-product-selectable-card
          (click)="onCardClicked(SeatKind.Recruitment)"
          [productName]="'tlc.common.brand.recruitee' | translate"
          [productType]="'tlc.common.brand_type.recruitee' | translate"
          [text]="'tlc.org.add_dialog.apps.recruitee.description' | translate"
          [isActive]="selectedSeatKind[SeatKind.Recruitment]"
          iconName="tellent-apps-ats"
        />
      </div>
      <div class="card-container">
        <rt-product-selectable-card
          (click)="onCardClicked(SeatKind.CoreHR)"
          [productName]="'tlc.common.brand.hr' | translate"
          [productType]="'tlc.common.brand_type.hr' | translate"
          [text]="'tlc.org.add_dialog.apps.kiwi.description' | translate"
          [isActive]="selectedSeatKind[SeatKind.CoreHR]"
          iconName="tellent-apps-hr-bg"
        />
      </div>
    </section>
    <section>
      <rt-form-field>
        <rt-label>{{ 'tlc.org.add_dialog.language' | translate }}</rt-label>
        <rt-select
          formControlName="language"
          [options]="tellentAndCoreSupportedLanguagesOptions"
          [hasSearch]="false"
        />
      </rt-form-field>
    </section>
    <section>
      <rt-form-field>
        <rt-checkbox formControlName="sampleData">
          <div layout-vertical>
            <strong> {{ 'tlc.org.add_dialog.sample_data.heading' | translate }}</strong>
            <span>{{ 'tlc.org.add_dialog.sample_data.description' | translate }}</span>
          </div>
        </rt-checkbox>
      </rt-form-field>
    </section>

    <section class="legal">
      <div
        [innerHTML]="
          'tlc.org.add_dialog.legal'
            | translate: { terms_link: links.termsLink, privacy_link: links.privacyLink }
        "
      ></div>
    </section>
  </form>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="onCancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    [disabled]="!form.dirty || form.invalid"
    variant="primary"
    (click)="onAddCompany()"
    [loading]="loading()"
  >
    {{ 'tlc.org.add_dialog.cta' | translate }}
  </rt-button>
</rt-dialog-footer>
